import React from 'react';

import { Alert, Button, Skeleton } from 'antd';

/** Load state of a report block; `ready` renders its content. */
export type SectionStatus =
  | { kind: 'ready' }
  | { kind: 'loading' }
  | { kind: 'error'; message: string; retryLabel: string; onRetry: () => void };

interface SectionStatusContentProps {
  status?: SectionStatus;
  children: React.ReactNode;
}

/** Shows the block content, a skeleton while loading, or the failure with a retry action. */
const SectionStatusContent: React.FC<SectionStatusContentProps> = ({ status, children }) => {
  if (status?.kind === 'loading') return <Skeleton active paragraph={{ rows: 4 }} title={false} />;
  if (status?.kind === 'error') {
    return (
      <Alert
        type="warning"
        showIcon
        message={status.message}
        action={
          <Button size="small" onClick={status.onRetry}>
            {status.retryLabel}
          </Button>
        }
      />
    );
  }
  return <>{children}</>;
};

export default SectionStatusContent;
